module.exports = __webpack_public_path__ + "static/media/grass.a3785d79.jpg";